import { Injectable } from '@angular/core';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IID_ESPLETATO_OK_CHECKLIST_GISFO } from '@common/interfaces/interfaceData';
import { IIDEspletatoOkChecklistGISFOStore } from './espletatoOkChecklistGISFO.store';
import { IIDEspletatoOkChecklistGISFOQuery } from './espletatoOkChecklistGISFO.query';
import { WsACKCallback } from '@common/api/ack';
import { EspletatoOkGISFOOptions } from '@common/interfaces/interfaceSettings';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.ESPLETATO_OK_CHECKLIST_GISFO)
export class IIDEspletatoOkChecklistGISFOService extends CrudService<
  IID_ESPLETATO_OK_CHECKLIST_GISFO,
  IIDEspletatoOkChecklistGISFOStore,
  IIDEspletatoOkChecklistGISFOQuery
> {
  constructor(
    protected store: IIDEspletatoOkChecklistGISFOStore,
    public query: IIDEspletatoOkChecklistGISFOQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(Topics.IID_ESPLETATO_OK_CHECKLIST_GISFO, store, query, actionService, updateStrategy);
  }

  createInGISFO(dto: { id: string; tipoCl: number }, callback?: WsACKCallback<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>) {
    this.featureCommandService.send<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>(
      {
        target: 'feature:espletato-ok-checklist-gisfo',
        command: 'create-in-gisfo',
        dto,
        ...this.projectIdFromEntity(dto.id),
      },
      () => this.actionService.sendMessage(Topics.IID_ESPLETATO_OK_CHECKLIST_GISFO, 'createInGisfo', dto, callback),
      callback,
    );
  }

  saveInGISFO(dto: { id: string, settings: EspletatoOkGISFOOptions }, callback?: WsACKCallback<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>) {
    this.featureCommandService.send<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>(
      {
        target: 'feature:espletato-ok-checklist-gisfo',
        command: 'save-in-gisfo',
        dto,
        ...this.projectIdFromEntity(dto.id),
      },
      () => this.actionService.sendMessage(Topics.IID_ESPLETATO_OK_CHECKLIST_GISFO, 'saveInGisfo', dto, callback),
      callback,
    );
  }

  closeInGisfo(dto: { id: string }, callback?: WsACKCallback<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>) {
    this.featureCommandService.send<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>(
      {
        target: 'feature:espletato-ok-checklist-gisfo',
        command: 'close-in-gisfo',
        dto,
        ...this.projectIdFromEntity(dto.id),
      },
      () => this.actionService.sendMessage(Topics.IID_ESPLETATO_OK_CHECKLIST_GISFO, 'closeInGisfo', dto, callback),
      callback,
    );
  }

  sendPhotosToGISFO(dto: { id: string }, callback?: WsACKCallback<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>) {
    this.featureCommandService.send<Partial<IID_ESPLETATO_OK_CHECKLIST_GISFO>>(
      {
        target: 'feature:espletato-ok-checklist-gisfo',
        command: 'send-photos-to-gisfo',
        dto,
        ...this.projectIdFromEntity(dto.id),
      },
      () => this.actionService.sendMessage(Topics.IID_ESPLETATO_OK_CHECKLIST_GISFO, 'sendPhotosToGisfo', dto, callback),
      callback,
    );
  }

  private projectIdFromEntity(id: string): { projectId?: string } {
    const projectId = this.query.getEntity(id)?.projectId;
    return projectId ? { projectId } : {};
  }
}
